import Chats from "./Chats";
import { ImAttachment } from "react-icons/im";
import { IoSend } from "react-icons/io5";
import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateSelectedMessage } from "../../../slice/MessageSlice";

const MessageDetail = ({ selecetedMessage, store, socket }) => {
  const [newMesssage, setNewMessage] = useState("");
  const [isUserOnline, setIsUserOnline] = useState(false);
  /* console.log(selecetedMessage); */
  const bottom = useRef(null);

  const { user } = useSelector((state) => state.webStoreUser);
  const dispatch = useDispatch();

  useEffect(() => {
    bottom.current.scrollIntoView({ behavior: "smooth" });
    console.log(selecetedMessage);
    socket.on("userDisconnected", (data) => {
      console.log(selecetedMessage.customer.id);
       if(selecetedMessage.customer.id === data.userID){
            
        setIsUserOnline(false);
      } 
    });
    /* user coneected */
      socket.on("userConnected", (data) => {
      console.log(selecetedMessage.customer.id);
      if(selecetedMessage.customer.id === data.userID){
            setIsUserOnline(true);
      }
      });

    return () => {
      socket.off("userDisconnected");
      socket.off("userConnected");
    };
  }, [selecetedMessage]);

  const sendMessageToConsumer = async () => {
    console.log("sending message", selecetedMessage.customer.id);

    dispatch(updateSelectedMessage({ message: newMesssage, senderID: store._id, time: new Date().toLocaleTimeString(), seen: false }));
    socket.emit("messageToConsumer", {
      message: newMesssage,
      room: selecetedMessage.customer.id,
      senderInfo: {
        storeID: store._id,
        storeOwnerID: user._id,
        storeName: store.storeName,
        storeImage: store.storeImage,
        lastMessage: newMesssage,
      },
      receiverInfo: {
        customerID: selecetedMessage.customer.id,
        fullName: selecetedMessage.customer.fullName,
        profileImage: selecetedMessage.customer.profileImage,
      },
    })
    setNewMessage("")
    ;
  };
  return (
    <>
      <div>
        <div className='messageDetailTitleDiv'>
          <img src={selecetedMessage?.customer.profileImage} />
          <div>
            <p className='NameMessageDetail'>{selecetedMessage.customer.fullName}</p>
            {selecetedMessage.customer.isOnline ? <p>online</p> : <p style={{color:"red"}} ></p>}
          </div>
        </div>

        <div className='messageContentDiv'>
          {selecetedMessage?.chats.map((chat) => (
            <Chats who={chat.senderID === store._id ? "self" : "not self"} key={chat._id} chat={chat} />
          ))}
          <div ref={bottom}></div>
        </div>
        <div className='messageInputDIv'>
          <div>
            <input
              value={newMesssage}
              onChange={(e) => setNewMessage(e.target.value)}
              
              className='inputMessage'
              type='text'
              placeholder='Type something..'
            />
            <ImAttachment />
          </div>
          <button onClick={sendMessageToConsumer}>
            <IoSend size={24} />
          </button>
        </div>
      </div>
    </>
  );
};

export default MessageDetail;
